import { useSelector } from "react-redux";
import { routeConstant } from "shared/routes/routeConstant";
import ProjectsList from "shared/components/dashboardCommon/projectsList";

const ClientArchivedProjects = () => {
  const auth = useSelector((state: any) => state.root.auth);

  return (
    <ProjectsList
      userType="client"
      pageTitle={`${auth?.user?.display_name || "Your"} Archived Projects`}
      pageDescription="Archived projects remain available here for up to 6 months."
      showSearchFilter={true}
      EnableApiIntegration={true}
      noContentMessage="No archived projects yet."
      detailRoutePath={routeConstant.client.projectDetail.path}
      isArchived={true}
      showArchiveButton={false}
    />
  );
};

export default ClientArchivedProjects;
